import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BRAND_LOGO_SQUARE } from './brandAssets';
import { initPostHog } from './services/posthog';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// Set favicon dynamically
const link = document.createElement('link');
link.rel = 'icon';
link.href = BRAND_LOGO_SQUARE;
document.head.appendChild(link);

// Remove any existing favicon
const existingFavicon = document.querySelector("link[rel*='icon']");
if (existingFavicon && existingFavicon.parentNode) {
  existingFavicon.parentNode.removeChild(existingFavicon);
}

// Initialize PostHog
const posthogClient = initPostHog();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {posthogClient ? (
      <PostHogProvider client={posthogClient}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);